.wechatProtectedMedia {
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  background-repeat: no-repeat;
  user-select: none;
}
